export default "__VITE_ASSET__d3570dd6__"